import getRolePermissions from './getRolePermissions';
import upsertRolePermission from './upsertRolePermission';
import deletePermission from './deletePermission';
import createPermission from './createPermission';

export default {
  getRolePermissions,
  upsertRolePermission,
  deletePermission,
  createPermission,
};
